module.exports = "\n<div class=\"comp-lazy-image\" :style=\"style\"><img v-on:imageLoaded=\"onImageLoaded\" v-on:imageLoading=\"onImageLoading\" v-img=\"src\" :alt=\"alt\" :size=\"size\">\n  <div class=\"loading-indicator\" v-if=\"loading\" v-spin-js-spinner></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/lazy_image/index.pug
// module id = 670
// module chunks = 4